import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import axios from "axios";
Vue.prototype.$axios = axios;

import {
  Dialog,
  Swipe,
  SwipeItem,
  Popup,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
  Toast,
  Overlay,
  Button,
  Loading 
} from "vant";
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Popup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Overlay);
Vue.use(Button);
Vue.use(Loading);
Vue.prototype.$toast = Toast;
import 'vant/lib/index.css';
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
